var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRa3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.1807V13.4034C0.5 14.0517 0.757466 14.6735 1.21579 15.1321C1.67412 15.5907 2.2958 15.8485 2.94414 15.8488H13.9473C14.5959 15.8488 15.2179 15.5912 15.6765 15.1326C16.1351 14.6739 16.3927 14.0519 16.3927 13.4034V12.1819",
    stroke: "#3B6EC9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4547 6.74574C11.6537 8.34645 10.0504 9.94974 8.44709 10.752C6.8438 9.94974 5.24052 8.34774 4.43823 6.74316",
    stroke: "#3B6EC9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4458 0.5V10.7086",
    stroke: "#3B6EC9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRa3);
export default __webpack_public_path__ + "static/media/ra-3.799786f77b02709be2ba35ab4b170715.svg";
export { ForwardRef as ReactComponent };